import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const SvgArrowCircleDownRight = ({ ...props }: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M15 9v6m0 0H9m6 0L9 9m13 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default SvgArrowCircleDownRight;
